<template>
  <div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data: () => {
    return { pageName: 'Hello World', msg: 'This is hello world page.' };
  },

  created: function() {
    this.$emit('PageNameChanged', this.pageName);
    console.log('PageNameChanged triggered from Helloworld page.');
  },
};
</script>
